import { ProblemDefinition } from './types';

const schemaDDL = `
CREATE TABLE departments (id INTEGER PRIMARY KEY, name TEXT NOT NULL, budget REAL);
CREATE TABLE employees (id INTEGER PRIMARY KEY, first_name TEXT NOT NULL, last_name TEXT NOT NULL, dept_id INTEGER, salary REAL, hire_date TEXT, manager_id INTEGER, FOREIGN KEY(dept_id) REFERENCES departments(id), FOREIGN KEY(manager_id) REFERENCES employees(id));
`;

const seedDML = `
INSERT INTO departments (id, name, budget) VALUES
  (1, 'Engineering', 500000),
  (2, 'Sales', 300000),
  (3, 'Marketing', 200000),
  (4, 'HR', 150000);

INSERT INTO employees (id, first_name, last_name, dept_id, salary, hire_date, manager_id) VALUES
  (1, 'Alice', 'Johnson', 1, 95000, '2020-03-15', NULL),
  (2, 'Bob', 'Smith', 1, 88000, '2021-06-01', 1),
  (3, 'Carol', 'Williams', 2, 72000, '2019-11-20', NULL),
  (4, 'David', 'Brown', 2, 65000, '2022-01-10', 3),
  (5, 'Eva', 'Davis', 3, 78000, '2020-07-22', NULL),
  (6, 'Frank', 'Miller', 1, 92000, '2018-09-05', 1),
  (7, 'Grace', 'Wilson', NULL, 60000, '2023-02-14', NULL),
  (8, 'Henry', 'Taylor', 3, 70000, '2021-04-30', 5),
  (9, 'Ivy', 'Anderson', 4, 67000, '2022-08-18', NULL),
  (10, 'Jack', 'Thomas', NULL, 55000, '2023-05-01', NULL);
`;

export const groupbyProblems: ProblemDefinition[] = [
 {
  id: 'groupby-easy-1',
  title: 'Count Employees per Department',
  statement: `Write a query to count the number of employees in each department.\n\nReturn the **dept_id** and the **count** (aliased as \`employee_count\`). Only include employees who have a department assigned (non-NULL dept_id).`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['dept_id', 'employee_count'],
   values: [
    [1, 3],
    [2, 2],
    [3, 2],
    [4, 1],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['groupby'],
  hints: [
   'Use GROUP BY dept_id to group employees by their department.',
   'Use COUNT(*) to count rows in each group.',
   'Add WHERE dept_id IS NOT NULL to exclude unassigned employees.',
  ],
 },
 {
  id: 'groupby-easy-2',
  title: 'Average Salary by Department',
  statement: `Write a query to calculate the **average salary** for each department.\n\nReturn the **dept_id** and the **average salary** (aliased as \`avg_salary\`). Only include employees with a department assigned.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['dept_id', 'avg_salary'],
   values: [
    [1, 91666.6666666667],
    [2, 68500.0],
    [3, 74000.0],
    [4, 67000.0],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['groupby'],
  hints: [
   'Use AVG(salary) to compute the average salary per group.',
   'GROUP BY dept_id groups rows by department.',
  ],
 },
 {
  id: 'groupby-medium-1',
  title: 'Departments with High Average Salary',
  statement: `Write a query to find departments where the **average salary exceeds 75,000**.\n\nReturn the **dept_id** and the **average salary** (aliased as \`avg_salary\`). Use HAVING to filter grouped results.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['dept_id', 'avg_salary'],
   values: [
    [1, 91666.6666666667],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['groupby'],
  hints: [
   'HAVING is like WHERE but for grouped/aggregated results.',
   'Use HAVING AVG(salary) > 75000 after the GROUP BY clause.',
   'Remember: WHERE filters rows before grouping, HAVING filters groups after aggregation.',
  ],
 },
 {
  id: 'groupby-medium-2',
  title: 'Max Salary per Department with Names',
  statement: `Write a query to find the **maximum salary** in each department along with the **department name**.\n\nReturn the **department name** (as \`name\`) and the **maximum salary** (aliased as \`max_salary\`). Join employees with departments and group by department name.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['name', 'max_salary'],
   values: [
    ['Engineering', 95000],
    ['Sales', 72000],
    ['Marketing', 78000],
    ['HR', 67000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['groupby'],
  hints: [
   'JOIN employees with departments to get department names.',
   'Use MAX(salary) to find the highest salary in each group.',
   'GROUP BY departments.name (or d.name if you alias the table).',
  ],
 },
];
